<template>
    <nav class="navbar navbar-dark bg-dark fixed-top px-0" style="background-color: var(--purple) !important;">
        <Row type="container">
            <IconButton icon="bars" variant="light" :do-action="showSidebar"/>
            <router-link :to="$i18nHelper.getUrl('')" class="text-decoration-none">
                <span class="text-light font-weight-bold text-uppercase pl-2">{{ appName }}</span>
            </router-link>
            <LanguageSwitcher class="nav-item"/>

        </Row>
    </nav>
</template>

<script>
import IconButton from "./IconButton";
import LanguageSwitcher from "./LanguageSwitcher";
import Row from "@/components/html/Row";

export default {
    data() {
        return {
            appName: process.env.VUE_APP_NAME,
        }
    },
    name: "AppBar",
    components: {Row, LanguageSwitcher, IconButton},
    methods: {
        showSidebar() {
            this.$root.showSidebar = true
        },

    },
}
</script>

<style scoped>

</style>